import React from 'react';

import { createRoot } from 'react-dom/client';

import '@shipstation/style-sheet-helpers/style.less';
import * as Cookies from '../../constants/cookies';
import { CookieService } from '../../services/cookie-service';
import { LogService } from '../../services/log-service';
import './login.css';
import AuthPageProvider from '../auth-page-provider';
import LoginForm from './login-form';
import IDPLoginPage from '../../pages/idp/login-page';
import Modernizr from '../../../modernizr';
import { setupAxios } from '../../setup-axios';

setupAxios({ isNativeAuth: true });
const RenderLoginForm = () => {
  const params = new URL(document.location).searchParams;
  const successfullyVerified = params.get('verified') === 'true';
  const sessionExpired = params.get('sessionExpired') === 'true';
  const isRedirectedFromMarketingSignup = params.get('firsttime') === 'true';
  const redirect = params.get('redirect');

  const showLoggedOutForMaintenance = CookieService.getCookieValue(Cookies.NeedsLoggedOutForMaintMsg);
  const customErrorMsg = CookieService.getCookieValue(Cookies.AuthErrorOrLogoutMsg);
  if (showLoggedOutForMaintenance) {
    CookieService.removeCookie(Cookies.NeedsLoggedOutForMaintMsg);
  } else if (customErrorMsg) {
    CookieService.removeCookie(Cookies.AuthErrorOrLogoutMsg);
  }

  const LoginPage =
    window.location.pathname === '/idp/login' ? (
      <IDPLoginPage />
    ) : (
      <LoginForm
        customErrorMsg={customErrorMsg}
        isRedirectedFromMarketingSignup={isRedirectedFromMarketingSignup}
        redirect={redirect}
        sessionExpired={sessionExpired}
        shouldRenderRememberMe
        showLoggedOutForMaintenance={showLoggedOutForMaintenance}
        successfullyVerified={successfullyVerified}
      />
    );

  return <AuthPageProvider>{LoginPage}</AuthPageProvider>;
};

const trackEvent = (feature) => window.analytics.track('browserWarning missing feature', feature);

const unsupportedFeaturesInUsersBrowser = Object.keys(Modernizr).filter((key) => !Modernizr[key]);
const isModernBrowser = unsupportedFeaturesInUsersBrowser.length === 0;
if (!isModernBrowser) {
  try {
    const browserWarning = document.getElementById('browser-warning');
    browserWarning.style.display = 'block';
    if (window.analytics) {
      unsupportedFeaturesInUsersBrowser.forEach((feature) => trackEvent(feature));
    }
  } catch (e) {
    LogService.logError(e);
  }
}

const loadCover = document.querySelector('.load-cover');
loadCover.parentNode.removeChild(loadCover);

// we should render the login form regardless
const root = createRoot(document.getElementById('login-form-wrapper'));
root.render(<RenderLoginForm />);
